import React, { useState, useEffect } from "react";
import {
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Button,
  Box,
  Alert,
  CircularProgress,
  IconButton,
  Typography,
  Divider,
  InputLabel,
  Checkbox,
  OutlinedInput,
  ListItemText,
  Avatar,
  Grid,
  FormGroup,
  Paper
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useAlert } from "../alerts/AlertContext";
import AxiosInstance from "../../services/AxiosInstance";
import { API_PERMISSION_URL, MODULE_URL, API_PERMISSION_SECRET_URL } from "../../Constants/Constants";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { parse, format } from "date-fns";

function ApiForm({ open, onClose, editData = null, onSuccess, isEditMode = false }) {
  
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
      name: "",
      active: true,
  });
  
  const [errors, setErrors] = useState({});
  const [selectedModule, setSelectedModule] = useState();
  const [modules, setModules] = useState([]);  
  const [apiUri, setApiUri] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [format, setFormat] = useState("curl");
  const CRUD_KEYS = ["create", "list", "readById", "update", "delete"];

  
  const [crud, setCrud] = useState({
    create: false,
    list: false,
    readById: false,
    update: false,
    delete: false
  });

  
  
  const isAllChecked = CRUD_KEYS.every((k) => crud[k]);
  const isIndeterminate =
    !isAllChecked && CRUD_KEYS.some((k) => crud[k]);

  const handleCrudChange = (e) => {
    const { name, checked } = e.target;
    setCrud((prev) => ({ ...prev, [name]: checked }));
  };

  const handleAllChange = (e) => {
    const checked = e.target.checked;
    const updated = {};
    CRUD_KEYS.forEach((k) => (updated[k] = checked));
    setCrud(updated);
  };


  const labelMap = {
    create: "CREATE",
    list: "LIST",
    readById: "READ BY ID",
    update: "UPDATE",
    delete: "DELETE"
  };

  

  const showAlert = useAlert();
  const [api, setApi] = useState(null);

  // Initialize form data when dialog opens or editData changes
  useEffect(() => {
    getModules();    
    if (open) {       
      
      if (editData) {
        
        setSelectedModule(editData.module.id);
        setApiUri(editData.module.apiPattern);
        formData.active = editData.enable;
        setStartDate(new Date(editData.startDate));       
        setEndDate(new Date(editData.endDate));
         
        setCrud({
          create: editData.create,
          list: editData.read,
          readById: editData.readById,
          update: editData.update,
          delete: editData.delete
        })
      } else {
        // setFormData({
        //   name: "",
        //   seq: "",
        //   active: true,
        // });
      }
      //setErrors({});
    }
  }, [open, editData]);
  
    
   const getModules = () => {
    AxiosInstance.get(MODULE_URL).then((response) =>
      setModules(response.data)
    );
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {

        var api = {
            "enable": formData.active,
            "module" : {id: selectedModule},
            "startDate" : startDate,
            "endDate" : endDate,
            "create" : crud.create,
            "read": crud.list,
            "update": crud.update,
            "delete": crud.delete,
            "readById": crud.readById            
        }
        
        if(isEditMode) 
            api.id =  editData.id;

      await AxiosInstance.post(API_PERMISSION_URL, api);

      showAlert(
        `API ${isEditMode ? "updated" : "created"} successfully!`,
        "success"
      );

      onSuccess?.();
      onClose();
    } catch (error) {
      showAlert("Error saving API:", "error");
      showAlert(
        `API ${isEditMode ? "update" : "creation"} failed!`,
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

   const [logos, setLogos] = useState({
    global: null,
    footer: null,
    favicon: null
  });

  const handleModuleChange = (event) => {
    setSelectedModule(event.target.value);
    const api_url = modules.find(m => m.id === event.target.value)?.apiPattern;
    setApiUri(api_url);
    //handleFormData(event);
  };


  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const API_MAP = {
  create: {
    method: "POST",
    url: "/api/tickets",
    curl: `curl -X POST http://localhost:8080/api/tickets \
          -H "Authorization: Bearer <TOKEN>" \
          -H "Content-Type: application/json" \
          -d '{"title":"Test Ticket","priority":"HIGH"}'`,
    powershell: `Invoke-RestMethod -Method POST \
          -Uri "http://localhost:8080/api/tickets" \
          -Headers @{ Authorization="Bearer <TOKEN>" } \
          -Body '{ "title":"Test Ticket", "priority":"HIGH" }' \
          -ContentType "application/json"`
  },
  list: {
    method: "GET",
    url: "/api/tickets",
    curl: `curl -X GET http://localhost:8080/api/tickets \
          -H "Authorization: Bearer <TOKEN>"`,
    powershell: `Invoke-RestMethod -Method GET \
          -Uri "http://localhost:8080/api/tickets" \
          -Headers @{ Authorization="Bearer <TOKEN>" }`
  },
  readById: {
    method: "GET",
    url: "{URL}/{id}",
    curl: `curl -X GET http://localhost:8080{URL}/101 \
          -H "X-API-KEY: {API_KEY}" -H "X-API-SECRET: {API_SECRET}"`,
    powershell: `Invoke-RestMethod -Method GET \
          -Uri "http://localhost:8082{URL}/101" \
          -Headers @{ "X-API-KEY"= "{API_KEY}"; "X-API-SECRET"= "{API_SECRET}"}`
  },
  update: {
    method: "PUT",
    url: "/api/tickets/{id}",
    curl: `curl -X PUT http://localhost:8080/api/tickets/101 \
          -H "Authorization: Bearer <TOKEN>" \
          -H "Content-Type: application/json" \
          -d '{"status":"RESOLVED"}'`,
    powershell: `Invoke-RestMethod -Method PUT \
          -Uri "http://localhost:8080/api/tickets/101" \
          -Headers @{ Authorization="Bearer <TOKEN>" } \
          -Body '{ "status":"RESOLVED" }' \
          -ContentType "application/json"`
            },
    delete: {
      method: "DELETE",
      url: "/api/tickets/{id}",
      curl: `curl -X DELETE http://localhost:8080/api/tickets/101 \
            -H "Authorization: Bearer <TOKEN>"`,
      powershell: `Invoke-RestMethod -Method DELETE \
            -Uri "http://localhost:8080/api/tickets/101" \
            -Headers @{ Authorization="Bearer <TOKEN>" }`
    }
  };


  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: 450,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >      
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {isEditMode ? (
            <EditIcon color="primary" />
          ) : (
            <AddIcon color="primary" />
          )}
          <Typography variant="h6" component="span">
            {isEditMode ? "Edit API" : "Add New API"}
          </Typography>
        </Box>
        <IconButton
          onClick={handleClose}
          disabled={loading}
          size="small"
          sx={{ color: "grey.500" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 3 }}>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>            
            <Box
              sx={{
                display: "flex",
                gap: 2,          // space between dropdowns
                width: "100%",   // full parent width
              }}
            >
               <FormControl
                variant="outlined"
                fullWidth
                sx={{ m: 1, minWidth: 200 }}
                required                
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Module
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  name="module"                  
                  value={selectedModule}
                  onChange={handleModuleChange}
                  label="Module"
                >
                  {modules.map((mod) => (
                    <MenuItem value={mod.id}>{mod.name}</MenuItem>
                  ))}
                </Select>                
              </FormControl>
              <TextField
                  autoFocus
                  required
                  margin="dense"
                  id="outlined-multiline-static"
                  name="apiUri"
                  label="API Path"
                  type="text"
                  variant="outlined"
                  fullWidth
                  value={apiUri}                 
                  disabled
                />
             
            </Box>

             <Box p={3}>
                <Typography variant="h6">CRUD Permissions</Typography>

                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isAllChecked}
                        indeterminate={isIndeterminate}
                        onChange={handleAllChange}
                      />
                    }
                    label="ALL"
                  />

                  {CRUD_KEYS.map((key) => (
                    <FormControlLabel
                      key={key}
                      control={
                        <Checkbox
                          name={key}
                          checked={crud[key]}
                          onChange={handleCrudChange}
                        />
                      }
                      label={labelMap[key]}
                    />
                  ))}
                </FormGroup>

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6">Output Format</Typography>
                 <RadioGroup
                    row
                    value={format}
                    onChange={(e) => setFormat(e.target.value)}
                  >
                    <FormControlLabel value="curl" control={<Radio />} label="cURL" />
                    <FormControlLabel
                      value="powershell"
                      control={<Radio />}
                      label="PowerShell"
                    />
                  </RadioGroup>

                <Divider sx={{ my: 2 }} />

                 {CRUD_KEYS.filter((k) => crud[k]).map((key) => {
                    const api = API_MAP[key];

                    return (
                      <Paper key={key} sx={{ p: 2, mb: 2 }}>
                        <Typography fontWeight="bold">
                          {api.method} {api.url.replace("{URL}", apiUri)}
                        </Typography>

                        <Typography variant="caption">
                          {format === "curl" ? "cURL" : "PowerShell"}
                        </Typography>

                        <pre>{api[format].replace("{URL}", apiUri)}</pre>
                      </Paper>
                    );
                  })}
              </Box>
            
            <Box sx={{ display: "flex", gap: 2, width: "100%", mt:1 }}>
                <DatePicker
                  label="Start"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  renderInput={(params) => <TextField {...params} value={startDate ? format(startDate, "MM/DD/YYYY") : ""} sx={{ mb: 2 }} fullWidth />}
                  //renderInput={(params) => <TextField {...params} fullWidth />}
                />

                <DatePicker
                  label="End"
                  value={endDate}
                  minDate={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Box>
              <Box sx={{ display: "flex", gap: 2, width: "100%", mt:1 }}>
                <FormControl component="fieldset" disabled={loading}>
                    <FormLabel
                    component="legend"
                    sx={{
                        color: "text.primary",
                        fontWeight: 500,
                        mb: 1,
                    }}
                    >
                    Enable
                    </FormLabel>
                    <RadioGroup
                    row
                    name="active"
                    value={formData.active}
                    onChange={(e) =>
                        handleInputChange("active", e.target.value === "true")
                    }
                    sx={{ ml: 1 }}
                    >
                    <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="YES"
                        sx={{ mr: 3 }}
                    />
                    <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="NO"
                    />
                    </RadioGroup>
                </FormControl>
            </Box>
          <Alert severity="info" sx={{ mt: 2, borderRadius: 2 }}>
            {isEditMode
              ? "You are editing an existing API."
              : "You are adding a new API."}
          </Alert>          
        </Box>
        </LocalizationProvider>
        </ThemeProvider>
      </DialogContent>

      <Divider />

     <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={handleClose}
          disabled={loading}
          variant="outlined"
          sx={{ borderRadius: 2 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={loading}
          variant="contained"
          startIcon={loading ? <CircularProgress size={16} /> : <SaveIcon />}
          sx={{
            borderRadius: 2,
            minWidth: 120,
          }}
        >
          {loading ? "Saving..." : isEditMode ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ApiForm;
